import { Card, Button, Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { EventItem } from "../models/models";
import { isUpcoming } from "../services/date";

export const EventsSection = ({ data = undefined, handleOnClick, handleOnClickPastEvents }: { data: EventItem[] | undefined, handleOnClick: (eventItem: EventItem) => void, handleOnClickPastEvents: () => void }) => {
  
  if (!data) return null;
  const hasPassedEvents = data.some(eventItem => eventItem.passed);

  return (
    <section id="events" className="pb-5 bg-quaternary">
      <Container className="my-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Upcoming Events</h2>
          {hasPassedEvents && (
            <Button variant="outline-primary" onClick={() => handleOnClickPastEvents()}>
             Go to past events
            </Button>
          )}
        </div>
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {data
            .filter((eventItem) => isUpcoming(eventItem.expireDate))
            .map((eventItem, index) => (
              <SwiperSlide key={index}>
                <Card className="shadow">
                  <Card.Body>
                    <Card.Text>
                      <strong className="d-block">{eventItem.period}</strong>
                      <span className="text-primary">{eventItem.place}</span>
                    </Card.Text>
                    <Card.Title>{eventItem.title}</Card.Title>
                    {eventItem.text || (eventItem.attachments && eventItem.attachments?.length > 0) ? (
                    <Button variant="primary" onClick={() => handleOnClick(eventItem)}>
                      Read more
                    </Button>
                  ) : null}
                  </Card.Body>
                </Card>
              </SwiperSlide>
            ))}
        </Swiper>
      </Container>
    </section>
  );
};
